module.exports = __webpack_public_path__ + "assets/img/elegance-rtm-intera.e16fa22e.png";